module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap2"
    }
  }, [_vm._v("The Tale of Gorgik")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Because we must deal with the unknown, whose nature is by definition speculative and outside the flowing chain of language, whatever we make of it will be no more than probability and no less than error. The awareness of possible error in speculation and of a continued speculation regardless of error is an event in the history of modern rationalism whose importance, I think, cannot be overemphasized … Nevertheless, the subject of how and when we become certain that what we are doing is quite possibly wrong "), _c('i', [_vm._v("but at least a beginning")]), _vm._v(" has to be studied in its full historical and intellectual richness.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDWARD SAID")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("Beginnings, Intention and Method")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1989a45f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/OPS/8-chap2.vue
// module id = 93
// module chunks = 0